<template>
  <header>
    <div class="container" @click="delProductValue()">
      <div class="logo_view">
        <img src="../assets/logo.png" alt="logo" style="height: 35px" @click="toHome">
      </div>
      <a-menu v-model="current" mode="horizontal" style="margin-left: 86px;margin-right: 48px">
        <a-menu-item key="1" @click="goPageURL({key: 1, label: '/products'})" style="margin-right: 75px">
          <span @mouseenter="mouseenter" @mouseleave="mouseleave" class="product-item-name"
                style="font-family: Roboto;font-weight: 600;">Products <a-icon type="down"/>
            <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
            <div>
              <div class="ant-dropdown ant-dropdown-placement-bottomCenter" style="left: -378px; top: 33px;"
                   v-if="show">
                <div class="product-modal-item ant-dropdown-content" @mouseenter="mouseenter" @mouseleave="mouseleave"
                     @click="e => e.stopPropagation()">
                  <a-row>
                    <a-col span="7" class="product-modal-menu">
                      <ul role="menu" class="ant-menu ant-menu-inline ant-menu-root ant-menu-light"
                          v-if="tagsList && tagsList.length > 0">
                        <li v-for="(tag) in tagsList" role="menuitem"
                            :class="'ant-menu-submenu ant-menu-submenu-inline ' + (selectKey === tag.id ? 'ant-menu-item-selected' : '')">
                          <div class="ant-menu-submenu-title" style="padding-left: 24px;">
                            <div style="font-size: 18px; width: 90%; overflow-y: hidden; text-overflow: ellipsis;"
                                 @click="clickMenu($event, tag.id)">{{ tag.name }}</div><i
                            class="header-product-menu-arrow"></i>
                          </div>
                        </li>
                      </ul>
                      <a-divider></a-divider>
                      <ul role="menu" class="ant-menu ant-menu-inline ant-menu-root ant-menu-light"
                          v-if="menuData && menuData.length > 0">
                        <li v-for="(menu) in menuData" role="menuitem"
                            :class="'ant-menu-submenu ant-menu-submenu-inline ' + (selectKey === menu.id ? 'ant-menu-item-selected' : '')">
                          <div class="ant-menu-submenu-title" style="padding-left: 24px;">
                            <div style="font-size: 18px; width: 90%; overflow-y: hidden; text-overflow: ellipsis;"
                                 @click="clickMenu($event, menu.id)">{{ menu.name }}</div><i
                            class="header-product-menu-arrow"></i>
                          </div>
                        </li>
                      </ul>
                    </a-col>
                    <a-col span="17" class="product-modal-content product_box">
                      <div style="padding: 0px 7px 0px 25px;">
                        <a-row v-if="selectType === 0">
                          <a-col span="20" style="font-size: 20px;color: #333282;">{{ selectTitle }}</a-col>
                          <a-col span="4" style="font-size: 16px;text-align:right;"><a style="color: #333282;"
                                                                                       @click="toMore">More <a-icon
                            type="right"/></a></a-col>
                        </a-row>
                        <a-row class="product_view" v-if="selectType === 0">
                            <a-skeleton :loading="spinning" active :paragraph="{rows: 14}">
                              <div class="product_list" v-if="dataList.length>0">
                                <div class="list_box" v-for="(item,index) in dataList" :key="index"
                                     @click="toDetailsDes(item)">
                                  <div class="img_box">
                                    <img class="img1" :src="item.productImg|imgFilter(360)">
                                    <img class="img2" :src="item.productTemplateImg|imgFilter(360)">
                                  </div>
                                  <span class="name" :title="item.productNameEn">{{ item.productNameEn }}</span>
                                  <span class="price">Start from $ {{ item.minPrice }}</span>
                                  <span class="price" style="margin-top: 12px;margin-bottom: 12px;" :title="item.spec">{{
                                      item.spec
                                    }}</span>
                                </div>
                              </div>
                              <div class="empty_box" v-else>
                                <img src="../assets/empty.png">
                              </div>
                            </a-skeleton>
                        </a-row>
                        <a-row v-if="selectType === 1">
                          <ul style="column-count:3;line-height: 2.5">
                            <li v-for="(menu) in selectMenuData" style="font-size: 16px;margin-bottom: 10px;">
                              <a style="color: #666666;font-size: 18px;font-family: Roboto;font-weight: 600;"
                                 @click="toProducts(menu.id)">{{ menu.name }}</a>
                              <ul v-if="menu.children.length > 1" style="font-size: 16px;color: #485256;">
                                <li v-for="(third) in menu.children" style="font-weight: 400;">
                                  <a style="color: #333333;" @click="toProducts(third.id)">{{ third.name }}<span
                                    v-if="false" class="new">New</span></a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </a-row>
                        <a-row v-if="selectType === 1" style="position: absolute; bottom: 12px; right: 132px;">
                          <a-col span="20" style="font-size: 20px;color: #333282;"></a-col>
                          <a-col span="4"
                                 style="font-size: 16px;text-align:right;font-family: Roboto;font-weight: 400;"><a
                            style="color: #333282;" @click="toMore">View All Products <a-icon type="right"/></a></a-col>
                        </a-row>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          </span>
        </a-menu-item>
        <a-menu-item key="2" @click="goPageURL({key: 2, label: '/about'})"
                     style="margin-right: 90px;font-family: Roboto;font-weight: 600;">About Us
        </a-menu-item>
        <a-menu-item key="3" @click="goPageURL({key: 3, label: 'Help Center'})"
                     style="margin-right: 90px;font-family: Roboto;font-weight: 600;">Help Center
        </a-menu-item>
      </a-menu>
      <div>
        <a-input-search @click.stop v-model="localProductName" placeholder="Search Products"
                        style="width: 300px" @click="handleClick"
                        @search="onSearch" @change="searchProductList"/>
        <a-divider type="vertical"/>
        <a-button type="primary" ghost @click="toSignIn" class="sign_in">
          Log in
        </a-button>
        <a-button type="primary" class="sign_up" @click="toSignUp">
          Sign up
        </a-button>
      </div>
    </div>

    <div class="search_box" v-if="productValue">
      <div v-if="searchList.length>0">
        <a-skeleton class="search_items" :loading="spinning1" active :paragraph="{rows: 19}">
          <div>
            <div class="wrapper_items">
              <div v-for="(item, index) in searchList" :key="index" @click="toDetailsDes(item)">
                <div class="list_items">
                  <img :src="item.productImg|imgFilter(200)">
                  <div>
                    <span class="name" :title="item.productNameEn">{{ item.productNameEn }}</span>
                    <span class="price">Start from $ {{ item.minPrice }}</span>
                    <span class="price" style="margin-top: 8px" :title="item.spec">{{
                        item.spec
                      }}</span>
                  </div>
                </div>
                <div class="divider"></div>
              </div>
            </div>
          </div>
        </a-skeleton>
        <div class="show_more">
          <span style="cursor: pointer" @click="onSearch(undefined)">View all {{ total }} products</span>
          <img src="../assets/arrow.png" style="margin-left: 3px">
        </div>
      </div>
      <div v-else class="empty">
        Nothing found
      </div>

    </div>
    <div class="service_chat">
      <div class="service_list">
        <a class="chat_item chat_skype" target="_blank" ref="nofollow" title="Click to Skype"
           href="skype:live:844966553?chat"></a>
        <a-popover overlayClassName="recharge-custom-popover" placement="left">
          <div class="chat_item chat_wechat" title="Wechat">
          </div>
          <template slot="content">
            <img src="../assets/service_wechat.png" style="width: 150px;height: 150px;">
          </template>
        </a-popover>
        <a-popover overlayClassName="recharge-custom-popover" placement="left">
          <div class="chat_lark" title="Lark"></div>
          <template slot="content">
            <img src="../assets/service_lark.png" style="width: 150px;height: 150px;">
          </template>
        </a-popover>
      </div>
      <a-back-top :visibility-height="0"/>
    </div>
  </header>
</template>

<script>
import EventBus from '../router/event-bus.js'
import {get, post} from '@/api'
import {getSeoLinkName, loadCustomScript, loadGTM} from '@/utils/utils'

export default {
  name: 'Header',
  components: {},
  props: {
    routeValue: {
      type: String
    },
    productName: {
      type: String,
      defaultValue: ''
    }
  },
  data () {
    return {
      show: false,
      productValue: undefined,
      localProductName: this.productName,
      spinning: true,
      spinning1: true,
      total: 0,
      tagsList: [],
      searchList: [],
      menuData: [],
      webAnalytics: new Map(),
      expandedMenuName: new Map(),
      selectMenuData: [],
      // 选中状态：0、标签，1、菜单
      selectType: 0,
      selectTitle: '',
      selectKey: '',
      dataList: [],
      current: [],
      queryParam: {
        pageNum: 1,
        pageSize: 6,
        categoryId: undefined,
        orderByType: undefined,
        tagIds: []
      }
    }
  },
  // 组件的其他逻辑和生命周期钩子

  mounted () {
    this.getWebAnalytics()
  },
  created () {
    // this.getMenuItem()
    // this.getMaterialClassify()
    const token = localStorage.getItem('SET_TOKEN')
    this.getTagsList()
    this.getCategoryList()
  },
  watch: {
    selectKey (val) {
      if (this.selectType === 0) {
        this.queryParam.tagIds = [this.selectKey]
        this.getProductList()
      }
    },
    localProductName (val) {
      this.productValue = val
    },
  },
  methods: {
    searchProductList (e) {
      const productName = this.localProductName ? this.localProductName.trim() : this.localProductName
      const customEventValue = productName || '' // 如果 productName 为空，则用空字符串代替
      EventBus.$emit('customEvent', customEventValue, 0)
      this.spinning1 = true
      post('/index/product/search', {
        pageNum: 1,
        pageSize: 16,
        productName: e.target.value ? e.target.value.trim() : e.target.value
      })
        .then(response => {
          this.spinning1 = false
          this.searchList = response.data.list
          this.total = response.data.total
          this.searchList.forEach(item => {
            const {specColorOptionVOS, specOptionsVOS} = item
            const spec = specColorOptionVOS.map(({
              colorOptionVOList,
              specsName
            }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
            const spec1 = specOptionsVOS.map(({
              optionNames,
              specsName
            }) => `${optionNames.length} ${specsName}`).join(' ')
            item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
          })
        }).catch(error => {
        this.spinning1 = false
      })

    },
    goPageURL (item) {
      if (item.key === 3) {
        this.current = []
        setTimeout(() => {
          window.open(process.env.VUE_APP_HELP_PC, '_blank')
        }, 300)
      } else {
        if (item.key === 1) {
          EventBus.$emit('customEvent', undefined, 2)
        }
        if (this.$route.path !== item.label) {
          this.$router.push({path: item.label})
        }
      }
    },
    handleClick () {
      this.searchProductList({target: {value: this.localProductName}})
      this.productValue = this.localProductName
      this.$forceUpdate()
    },
    onSearch (value) {
      this.delProductValue()
      EventBus.$emit('customEvent', this.localProductName, 1)
      if (this.$route.name !== 'Products') {
        this.$router.push({name: 'Products', params: {productName: this.localProductName}})
      }
    },
    toSignIn () {
      window.open(process.env.VUE_APP_FULFILLMENT, '_blank')
    },
    toSignUp () {
      window.open(process.env.VUE_APP_FULFILLMENT + 'user/register', '_blank')
    },
    toHome () {
      this.current = []
      if (this.$route.path !== '/') {
        this.$router.push({path: '/'})
      }
    },
    getTagsList () {
      get('/index/product/tags').then(response => {
        this.tagsList = response.data.children
        this.selectType = 0
        this.selectTitle = this.tagsList[0].name
        this.selectKey = this.tagsList[0].id
      }).catch(error => {
        console.error(error)
      })
    },
    getCategoryList () {
      get('/index/product/category').then(response => {
        this.menuData = response.data.children
        this.menuData.forEach(l1 => {
          this.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name)])
          if (l1.children) {
            l1.children.forEach(l2 => {
              if (l2.parentId !== null) {
                this.expandedMenuName.set(l2.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name)])
              }
              if (l2.children) {
                l2.children.forEach(l3 => {
                  this.expandedMenuName.set(l3.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name), getSeoLinkName(l3.name)])
                })
              }
            })
          }
        })
      }).catch(error => {
        console.error(error)
      })
    },
    getWebAnalytics () {
      get('/index/webAnalytics').then(response => {
        this.webAnalytics = response.data
        if (this.webAnalytics[0]) {
          this.webAnalytics[0].forEach(item => {
            if (item.content) {
              // eslint-disable-next-line no-inner-declarations
              function getGAMeasurementIdFromCode (code) {
                // 定义正则表达式模式
                const idRegex = /id=([^"']+)["']/
                // 使用 match() 方法检查代码是否与正则表达式匹配
                const match = code.match(idRegex)
                // 如果匹配成功,返回 ID 值
                if (match && match.length > 1) {
                  return match[1]
                }
                // 如果匹配失败,返回 null
                return null
              }

              item.pixId = getGAMeasurementIdFromCode(item.content)
            }
            loadGTM(item.pixId)
            window.dataLayer = window.dataLayer || []

            function gtag () {
              window.dataLayer.push(arguments)
            }

            gtag('js', new Date())
            gtag('config', item.pixId)
          })
        }
        if (this.webAnalytics[1]) {
          this.webAnalytics[1].forEach(item => {
            if (item.content) {
              loadCustomScript(item.content)
            }
          })
        }
        if (this.webAnalytics[2]) {
          this.webAnalytics[2].forEach(item => {
            loadCustomScript('<script type="text/javascript">' +
              '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');' +
              'fbq(\'init\', \'' + item.pixId + '\', {}, {\'agent\':\'printbelle\'});' +
              'fbq(\'init\', \'' + item.accessToken + '\', {}, {\'agent\':\'printbelle\'});' +
              'fbq(\'track\', "PageView");\n' +
              '<\/script>' +
              '<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + item.pixId + '&ev=PageView&noscript=1" /></noscript>')
          })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    mouseenter (e) {
      e.preventDefault()
      document.getElementsByClassName('anticon-down')[0].style.transform = 'rotate(-180deg)'
      this.show = true
    },
    mouseleave (e) {
      e.preventDefault()
      document.getElementsByClassName('anticon-down')[0].style.transform = 'unset'
      this.show = false
    },
    delProductValue () {
      this.productValue = undefined
    },
    clickMenu (e, key) {
      this.tagsList.forEach(item => {
        if (item.id === key) {
          this.selectType = 0
          this.selectTitle = item.name
          this.selectKey = item.id
        }
      })
      this.menuData.forEach(item => {
        if (item.id === key) {
          this.selectType = 1
          this.selectTitle = item.name
          this.selectKey = item.id
          this.selectMenuData = item.children
        }
      })
    },
    isShowTag (item, name) {
      const hasIsName = (item.tagList && item.tagList.some(item => item.showName && item.showName.toLowerCase() === name.toLowerCase())) || false
      return hasIsName
    },
    getProductList () {
      this.spinning = true
      post('/index/product/search', this.queryParam).then(response => {
        this.dataList = response.data.list
        this.dataList.forEach(item => {
          if (!item.productTemplateImg) {
            item['productTemplateImg'] = item.productImg
          }
          const {specColorOptionVOS, specOptionsVOS} = item
          const spec = specColorOptionVOS.map(({
            colorOptionVOList,
            specsName
          }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
          const spec1 = specOptionsVOS.map(({
            optionNames,
            specsName
          }) => `${optionNames.length} ${specsName}`).join(' ')
          item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
        })
        this.spinning = false
      }).catch(error => {
        this.spinning = false
        console.error(error)
      })
    },
    toDetailsDes (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
    toMore () {
      if (this.selectType === 0) {
        window.location.href = `/products?tagId=${this.selectKey}`
      } else {
        let names = this.expandedMenuName.get(this.selectKey)
        let urlParams = names.join('/')
        window.location.href = `/products/category/${urlParams}`
      }
    },
    toProducts (id) {
      if (this.selectType === 0) {
        window.location.href = `/products?tagId=${id}`
      } else {
        let names = this.expandedMenuName.get(id)
        let urlParams = names.join('/')
        window.location.href = `/products/category/${urlParams}`
      }
    }
  }
}
</script>
<style lang="less" src="../assets/css/font.scss"></style>
<style scoped lang="less">

.search_box {
  font-family: Roboto;
  z-index: 200;
  position: fixed;
  background: #FFFFFF;
  width: 1079px;
  color: #313131;
  border-radius: 2px;
  max-width: 100%;
  box-shadow: 2px 2px 15px rgba(0, 0, 0, .2);
  top: 66px;
  transition: all 0.5s;
  right: 35px;
  border-radius: 2px;

  ::-webkit-scrollbar {
    width: 5px;

  }

  ::-webkit-scrollbar-thumb {
    background-color: #343183;
    cursor: pointer;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    cursor: pointer;
  }

  .empty {
    text-align: center;
    padding: 10px;
    font-weight: 500;
    font-size: 14px;
  }

  .show_more {
    width: 100%;
    padding: 15px 0;
    text-align: center;
    background: #FFFFFF;
    position: absolute;
    color: #343183;
    font-size: 15px;
    bottom: 0;
  }

  .search_items {
    height: 678px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 12px 0 12px;
    margin-bottom: 40px;
    position: relative;


    .wrapper_items {
      flex-wrap: wrap;
      overflow-y: auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 24px;
      padding: 12px 12px 12px 0;

      .list_items:hover {
        background: #F8FAFC;
      }

      .divider {
        flex: 1;
        background: #eceff1;
        height: 1px;
        margin-left: 15px;
      }

      .list_items {
        padding: 16px;
        display: flex;
        cursor: pointer;

        img {
          width: 90px;
          height: 100px;
          object-fit: cover;
          border: 1px solid #DFE1E6;
        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 13px 10px 13px;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 1.4em;
        }

        .price {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 13px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
}

.container {
  width: 100%;
  display: flex;
  align-items: center;
  height: 96px;
  background: #FFFFFF;
  position: fixed;
  top: 0;
  z-index: 200;
  box-shadow: 0 10px 10px 0 rgba(1, 1, 1, 0.05);

  .logo_view {
    width: 196px;
    margin-left: 215px;
    cursor: pointer;
  }

  .menu {
    margin-left: 95px;
  }

  .sign_in {
    width: 88px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #C2C2C2;
    font-family: Roboto;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #353A47;
  }

  .sign_up {
    width: 87px;
    height: 35px;
    background: #343183;
    border-radius: 3px;
    font-family: Roboto;
    font-weight: 400;
    margin-left: 18px;
    font-size: 16px;
    text-align: center;
    color: #FFFFFF;
  }
}

.service_chat {
  position: fixed;
  right: 50px;
  bottom: 145px;
  z-index: 150;

  .chat_item {
    display: block;
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: url(../assets/icon_chat.png) no-repeat 0 0;
    margin-bottom: 6px;
  }

  .chat_skype {
    cursor: pointer;
    background-color: #5996ff;
    background-position: 0 -50px;
  }

  .chat_wechat {
    background-color: #59c682;
    background-position: 0 -200px;
  }

  .chat_lark {
    display: block;
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-image: url(../assets/icon_lark.svg);
    border: 1px solid #ccdfff;
    background-color: white;
    background-size: 100% 100%;
    margin-bottom: 6px;
  }
}

.product-modal-item {
  width: 870px;
  background-color: #fff;
  margin-top: 15px;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 15px 15px;
}

.anticon-down {
  transition: transform 333ms;
}

.product-modal-menu {
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #ddd;
  padding-top: 16px;
  border-radius: 0px 0 0 15px;
  padding-bottom: 16px;
  height: 696px;
}

.product-modal-content {
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #ddd;
  border-left: unset;
  padding-top: 16px;
  border-radius: 0 0 15px 0;
  padding-bottom: 16px;
  height: 696px;
}

/deep/ .ant-back-top {
  right: 60px;
  bottom: unset;

}

/deep/ .ant-back-top-content {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

/deep/ .ant-back-top-icon {
  margin: 13px auto;
  height: 24px;
  width: 20px;
}

//菜单打开状态/\箭头左/
/deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .header-product-menu-arrow::before {
  position: absolute;
  height: 1.5px;
  width: 8px;
  transform: rotate(45deg) translateX(3.6px);
  content: '';
  background: #fff;
  background: rgba(0, 0, 0, 0.65) \9;
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.65)), to(rgba(0, 0, 0, 0.65)));
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65));
  background-image: none \9;
  border-radius: 2px;
  -webkit-transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

//菜单打开状态/\箭头右\
/deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .header-product-menu-arrow::after {
  position: absolute;
  height: 1.5px;
  width: 8px;
  transform: rotate(-45deg) translateX(-3.6px);
  content: '';
  background: #fff;
  background: rgba(0, 0, 0, 0.65) \9;
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.65)), to(rgba(0, 0, 0, 0.65)));
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65));
  background-image: none \9;
  border-radius: 2px;
  -webkit-transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

//菜单收起状态\/箭头左\
/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow, /deep/ .ant-menu-submenu-inline .header-product-menu-arrow {
  position: absolute;
  height: 1.5px;
  top: 50%;
  right: 16px;
  width: 10px;
}

/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow::before, /deep/ .ant-menu-submenu-inline .header-product-menu-arrow::before {
  position: absolute;
  height: 1.5px;
  width: 8px;
  transform: rotate(-45deg) translateX(-3.6px);
  content: '';
  background: #fff;
  background: rgba(0, 0, 0, 0.65) \9;
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.65)), to(rgba(0, 0, 0, 0.65)));
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65));
  background-image: none \9;
  border-radius: 2px;
  -webkit-transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

//菜单收起状态\/箭头右/
/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow::after, /deep/ .ant-menu-submenu-inline .header-product-menu-arrow::after {
  position: absolute;
  height: 1.5px;
  width: 8px;
  transform: rotate(45deg) translateX(-3.6px);
  content: '';
  background: #fff;
  background: rgba(0, 0, 0, 0.65) \9;
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.65)), to(rgba(0, 0, 0, 0.65)));
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65));
  background-image: none \9;
  border-radius: 2px;
  -webkit-transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}


/deep/ .product_box {
  .product_view {
    display: flex;
    flex-direction: column;

    .empty_box {
      margin-top: 7%;
      display: flex;
      align-items: center;
      justify-content: center
    }

    .product_list {
      margin-bottom: 30px;
      display: flex;
      flex-wrap: wrap;
      position: relative;


      .list_box {
        width: 168px;
        height: 280px;
        cursor: pointer;
        display: flex;
        position: relative;
        margin-top: 20px;
        margin-right: 18px;
        flex-direction: column;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DFE1E6;

        .img_box {
          width: 140px;
          height: 140px;
          position: relative;
          margin-top: 12px;
          margin-left: 14px;
          overflow: hidden;
          border-radius: 3px;
          transition: all ease 0.3s;

          .img1 {
            width: 100%;
            height: 100%;
            opacity: 1;
            position: absolute;
            border-radius: 3px;
            top: 0;
            transition: all ease 0.6s;
          }

          .img2 {
            width: 100%;
            height: 100%;
            opacity: 0;
            border-radius: 3px;
            position: absolute;
            top: 0;
            transition: all ease 0.6s;
          }

        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 10px 13px 8px 13px;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 1.4em;
          height: 3em;
        }

        .price {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 13px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }

      }

      .list_box:hover .img_box .img1 {
        opacity: 0;
        transform: scale(1.1);
      }

      .list_box:hover .img_box .img2 {
        opacity: 1;
        transform: scale(1.1);
      }

    }

    .pagination {
      width: 1185px;
      display: flex;
      justify-content: end;

    }
  }

  .new {
    margin-left: 6px;
    width: 43px;
    background: #FFE0C5;
    border-radius: 3px;
    border: 1px solid #F6790F;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    color: #F6923D;
    padding: 0 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue